export default function (num) {
  const width = num || 750
  const dw = document.documentElement.clientWidth
  const _zoom = dw / width * 100
  // _zoom = _zoom < 90 ? _zoom : 90
  document.getElementsByTagName('html')[0].style.fontSize = _zoom + 'px'
}
